import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLongArrowAltUp,
  faLongArrowAltDown,
  faWifi,
  faSearch,
} from '@fortawesome/free-solid-svg-icons';

import StatusSelectDropdown from './CommandStatusSelectDropdown';

function CommandHistoryHeader({
  sort,
  handleSortClick,
  status,
  handleStatusSelect,
  jobName,
  handleSearch,
}) {
  return (
    <tr>
      <th
        scope="col"
        className="col-status align-middle pb-0 text-text-light-gray font-weight-normal three-quarter-text sticky-top bg-white border-0"
      >
        <StatusSelectDropdown
          selectedStatus={status}
          handleStatusSelect={handleStatusSelect}
        />
      </th>

      <th
        scope="col"
        className="col-main align-middle pb-0 text-text-light-gray font-weight-normal three-quarter-text sticky-top bg-white border-0"
      >
        <div className="input-group w-100">
          <div className="input-group-prepend">
            <span className="input-group-text text-brand-primary bg-transparent border-0 px-0">
              <FontAwesomeIcon icon={faWifi} size="sm" />
            </span>
          </div>
          <input
            type="text"
            className="form-control bg-transparent border-0 three-quarter-text"
            placeholder="Command Name"
            aria-label="commandNameSearch"
            value={jobName}
            onChange={handleSearch}
          />
          <div className="input-group-append">
            <span className="input-group-text bg-transparent border-0 pr-0">
              <FontAwesomeIcon
                className="text-text-light-gray"
                icon={faSearch}
                size="sm"
              />
            </span>
          </div>
        </div>
      </th>
      <th
        scope="col"
        className="col-main align-middle pb-0 col-date text-text-light-gray font-weight-normal three-quarter-text sticky-top bg-white border-0"
      >
        <button
          className="btn btn-link text-decoration-none three-quarter-text text-text-light-gray d-flex align-items-center justify-content-between p-0 w-100"
          onClick={() => handleSortClick()}
        >
          <span>{sort.by}</span>
          <div>
            {[
              [faLongArrowAltUp, 'asc'],
              [faLongArrowAltDown, 'desc'],
            ].map(([icon, sortDir]) => (
              <FontAwesomeIcon
                key={sortDir}
                icon={icon}
                className={
                  sort.direction === sortDir
                    ? 'text-text-light-gray font-weight-normal'
                    : 'text-icon-link-gray font-weight-light'
                }
                style={{ margin: '0 0.1rem' }}
              />
            ))}
          </div>
        </button>
      </th>
      <th
        scope="col"
        className="col-main align-middle pb-0 text-text-light-gray font-weight-normal three-quarter-text sticky-top bg-white border-0"
      >
        Fired By
      </th>
      <th
        scope="col"
        className="col-main align-middle pb-0 text-text-light-gray font-weight-normal three-quarter-text sticky-top bg-white border-0"
      >
        Response
      </th>
      <style jsx>{`
        .col-status {
          width: 16%;
        }
        .col-main {
          width: 21%;
        }
      `}</style>
    </tr>
  );
}

CommandHistoryHeader.propTypes = {
  sort: PropTypes.shape({
    by: PropTypes.oneOf(['Date']),
    direction: PropTypes.oneOf(['asc', 'desc']),
  }),
  handleSortClick: PropTypes.func,
  status: PropTypes.oneOf([
    '',
    'COMPLETED',
    'FAILED',
    'MESSAGE_SENT',
    'RUNNING',
    'PENDING',
  ]),
  handleStatusSelect: PropTypes.func,
  jobName: PropTypes.string,
  handleSearch: PropTypes.func,
};

CommandHistoryHeader.defaultProps = { sort: {} };

export default memo(CommandHistoryHeader);
